import { Empty, Modal, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ContainerInsumosPrecisao, QtdeContainer } from "./style";
import { InfoPrecisao } from "./tooltips/infoPrecisao";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";
import { obterListaInsumosLiquidos } from "./meta";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { orderBy } from "lodash";
import { SortButton } from "../insumosPrecisao/components/SortButton";
import { DefaultTitle } from "../defaultTitle";
import { Item__EquipeCliente } from "../../../../../../services/Equipe/GET";
import { typeInsumosDashboard } from "../insumosPrecisao";
import { ModalDetalhesInsumoLiquidos } from "./components/modalDetalhes";
import { numeroMilhar } from "../../../../../../utils";

//CONST
const segmento_permitido = ['', 'Todos', 'Insumos'];

//Props
interface Props {
    todas_atividades_ativas: Item__Atividades[];
    width?: string | number;
    segmento: string;
    data_propriedades: ItemPropriedades[];
    data_equipe_cliente: Item__EquipeCliente[];
}

export const InsumosPrecisaoLiquidos: React.FC<Props> = ({ todas_atividades_ativas, width, segmento, data_propriedades, data_equipe_cliente }) => {

    const [sortType, setSortType] = useState<'executada' | 'planejada' | 'precisao' | 'alfabetica'>('executada');
    const [insumo_selecionado, setInsumo_selecionado] = useState<typeInsumosDashboard>(null);
    const [open_modal, setOpen_modal] = useState<boolean>(false);

    const lista_insumos = obterListaInsumosLiquidos(todas_atividades_ativas) ?? [];

    const lista_ordenada = orderBy(lista_insumos, [
        (item) => {
            if (sortType === 'executada') return item.quantidade_executada;
            if (sortType === 'planejada') return item.quantidade_planejada;
            if (sortType === 'precisao') return item.precisao;
            if (sortType === 'alfabetica') return item.insumo_nome;
            return item.quantidade_executada;
        }
    ], [
        sortType === 'alfabetica' ? 'asc' : 'desc'
    ]);

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <ContainerInsumosPrecisao layout style={{ width: width, minWidth: width, maxWidth: width }} data-segmento={segmento} key={'insumos_precisao_liquidos'}>
                    <div className="ContainerInsumosPrecisao__header">
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                            <DefaultTitle title="Precisão Insumos Líquidos" />
                            <Tooltip title="Ordenar" placement="bottom"><samp>
                                <SortButton sortType={sortType} setSortType={setSortType} />
                            </samp></Tooltip>
                        </div>
                        <div className="ContainerInsumosPrecisao__header__ref">
                            <div className="ContainerInsumosPrecisao__header__ref__item">
                                <div className="ContainerInsumosPrecisao__header__ref__item__color"></div>
                                <p className="ContainerInsumosPrecisao__header__ref__item__text">Qtde planejada</p>
                            </div>
                            <div className="ContainerInsumosPrecisao__header__ref__item" data-executada={true}>
                                <div className="ContainerInsumosPrecisao__header__ref__item__color"></div>
                                <p className="ContainerInsumosPrecisao__header__ref__item__text">Qtde executada</p>
                            </div>
                        </div>
                    </div>

                    <div className="ContainerInsumosPrecisao__body">
                        <div className="ContainerInsumosPrecisao__body__list__header">
                            <p className="ContainerInsumosPrecisao__body__list__header__title">Insumo</p>

                            <p className="ContainerInsumosPrecisao__body__list__header__qtd">Quantidade</p>

                            <div className="ContainerInsumosPrecisao__body__list__header__progress">
                                <p className="ContainerInsumosPrecisao__body__list__header__progress__title">Precisão</p>
                                <Tooltip title={<InfoPrecisao />} color="white">
                                    <InfoCircleOutlined style={{ color: "var(--text-color-light)", cursor: "pointer" }} />
                                </Tooltip>
                            </div>
                        </div>

                        <div className="ContainerInsumosPrecisao__body__list">
                            {
                                lista_ordenada.length === 0 ? (
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sem dados" />
                                ) : (
                                    lista_ordenada.map(({ insumo_nome, quantidade_planejada, quantidade_executada, precisao, porcentagem, ordem, cod_insumo }, i) => (
                                        <div className="ContainerInsumosPrecisao__body__list__item" key={insumo_nome + i + 'liquidos'} onClick={() => { setInsumo_selecionado({ insumo_nome, quantidade_planejada, ordem, cod_insumo, quantidade_executada, precisao, porcentagem }); setOpen_modal(true); }}>

                                            <div className="ContainerInsumosPrecisao__body__list__item__header">
                                                <Tooltip title={insumo_nome}>
                                                    <p className="ContainerInsumosPrecisao__body__list__item__title">{String(insumo_nome).toLowerCase()}</p>
                                                </Tooltip>
                                                <QtdeLiquidos planejada={quantidade_planejada} executada={quantidade_executada} />
                                            </div>
                                            <div className="ContainerInsumosPrecisao__body__list__item__progress">
                                                <Tooltip title={<>Executado: <b>{porcentagem}%</b><br />Desvio: <b>{(porcentagem - 100).toFixed(2)}%</b><br />{quantidade_executada < quantidade_planejada ? 'Faltou' : 'Excedeu'}: <b>{numeroMilhar(Math.abs(quantidade_planejada - quantidade_executada))} L</b></>}>
                                                    <div className="ContainerInsumosPrecisao__body__list__item__progress__bar">
                                                        <div
                                                            className="bar-fill"
                                                            data-error={precisao < 80}
                                                            data-warning={precisao >= 80 && precisao < 95}
                                                            data-small={precisao >= 95 && precisao < 100}
                                                            data-precise={precisao === 100}
                                                            style={{ width: `${porcentagem * 0.8}%` }}
                                                        />
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                left: '80%',
                                                                top: 0,
                                                                bottom: 0,
                                                                width: '2px',
                                                                backgroundColor: '#333',
                                                                zIndex: 100
                                                            }}
                                                        />
                                                    </div>
                                                </Tooltip>
                                                <Tooltip title={`Precisão: ${precisao}`}>
                                                    <span>{precisao} %</span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                </ContainerInsumosPrecisao>
            )}

            <Modal
                open={open_modal}
                onOk={() => setOpen_modal(false)}
                onCancel={() => setOpen_modal(false)}
                title={insumo_selecionado?.insumo_nome}
                width={1000}
                footer={null}
                destroyOnClose
            >
                <ModalDetalhesInsumoLiquidos
                    insumo_selecionado={insumo_selecionado}
                    todas_atividades_ativas={todas_atividades_ativas}
                    data_propriedades={data_propriedades}
                    data_equipe_cliente={data_equipe_cliente}
                />
            </Modal>
        </AnimatePresence>
    );
}



//PROPS
interface PropsQtde {
    planejada: number;
    executada: number;
}

export const QtdeLiquidos = ({ planejada, executada }: PropsQtde) => {
    return (
        <QtdeContainer>
            <Tooltip title={`Planejada: ${planejada} L`}>
                <div className="QtdeContainer__item">
                    {planejada} L
                </div>
            </Tooltip>
            <div className="QtdeContainer__split" />
            <Tooltip title={`Executada: ${executada} L`}>
                <div className="QtdeContainer__item" style={{ fontWeight: executada >= 1000 ? 'bold' : '500' }}>
                    {executada} L
                </div>
            </Tooltip>
        </QtdeContainer>
    )
}
